import { Alarm } from '@app/models';
import {
  AlarmActionsUnion,
  AlarmActionTypes
} from '@core/actions/alarm.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface State extends EntityState<Alarm> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<Alarm> = createEntityAdapter<Alarm>({
  selectId: (alarm: Alarm) => alarm.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: AlarmActionsUnion
) {
  switch (action.type) {
    case AlarmActionTypes.Load:
      return { ...state, loading: true };

    case AlarmActionTypes.DeleteAlarmFail:
    case AlarmActionTypes.LoadFail:
      return { ...state, loading: false };

    case AlarmActionTypes.DeleteAlarmSuccess:
    case AlarmActionTypes.LoadSuccess:
      return { ...state, loading: false, loaded: true };

    case AlarmActionTypes.AddAll:
      return adapter.addAll(action.alarms, state);

    case AlarmActionTypes.AddPicture: {
      const id = action.file.AlarmId;
      const item = state.entities[id];
      if (item) {
        const pictures = [action.file, ...item.Pictures];
        return adapter.updateOne(
          { id, changes: { Pictures: pictures } },
          state
        );
      } else {
        return state;
      }
    }

    case AlarmActionTypes.AddOne:
      return adapter.addOne(action.alarm, state)

    case AlarmActionTypes.UpdateAlarm:
      return adapter.updateOne({ id: action.id, changes: action.alarm }, state);

    case AlarmActionTypes.DeleteAlarm:
      return adapter.removeOne(action.alarmId, state);

    default:
      return state;
  }
}

const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

const selectLoaded = (state: State) => state.loaded;
const selectLoading = (state: State) => state.loading;

const getState = createFeatureSelector<State>('alarms');

export const getAll = createSelector(getState, selectAll);
